export const DeliveryStatusSupplierPage = () => {
    return <>DeliveryStatusSupplierPage</>
}